import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { AemService } from '../services/aem.service'
import { UserInfoService } from '../services/user-info.service'
import { EnviormentConfig } from '../wcax-env-config';
import { CommonService } from '../services/common.service'


declare let $: any;

@Injectable()
export class ProductFilterService {

    private departmentSource = new BehaviorSubject<any[]>([]);
    currentDepartment = this.departmentSource.asObservable();

    private brandSource = new BehaviorSubject<any[]>([]);
    currentBrand = this.brandSource.asObservable();

    private filterAisleParamSource = new BehaviorSubject<string>('');
    currentFilterAisle = this.filterAisleParamSource.asObservable();

    private filterBrandParamSource = new BehaviorSubject<string>('');
    currentFilterBrand = this.filterBrandParamSource.asObservable();

    public _departments: any = [];

    public _brands: any = [];

    public _dealsCurrentFilter = new BehaviorSubject<any>(null);
    public dealsCurrentFilter$ = this._dealsCurrentFilter.asObservable();

    public objDeals = {
        isDeals: '',
        apiKey: ''
    }

    private config = EnviormentConfig;
    public currentEnv = '';

    public constructor(
        private _http: HttpClient,
        private _aemService: AemService,
        private _userInfoService: UserInfoService,
        private _commonService: CommonService
    ) { }

    public addDepartment(value) {
        const queryString = encodeURIComponent(value);
        const isValid = this.isExist(this._departments, queryString);
        if(isValid.length == 0){
            const objValue = {'query':queryString, 'text':value};
            this._departments.push(objValue);
            this.departmentSource.next(this._departments);
        }
    }
    
    public addBrand(brand) {
        const queryString = encodeURIComponent(brand);
        const isValid = this.isExist(this._brands, queryString);
        if(isValid.length == 0){
            const objValue = {'query':queryString,'text':brand};
            this._brands.push(objValue);
            this.brandSource.next(this._brands);
        }
    }
    
    private isExist(arr:any, value:string) {
       return arr.filter(function(objValue) {
            return objValue.query.toLowerCase().indexOf(value.toLowerCase()) > -1;
        })
    }
    
    public addFilterAisleParam(param) {
        this.filterAisleParamSource.next(param)
    }
    
    public addFilterBrandParam(param) {
        this.filterBrandParamSource.next(param);
    }

    /**
     * Get departments from AEM servlet
     * 
     * @param pageType returns (bogo or rewardcard) or (c-bogo or c-club-card)
     */
    public getDealsDepartments(){
        this.currentEnv = this._commonService.getCurrentEnviorment();
        if (this.objDeals.isDeals == 'c-bogo' || this.objDeals.isDeals == 'c-club-card'){     
            const httpOptions = {
                headers: new HttpHeaders({
                    'ocp-apim-subscription-key': this._aemService.getApimSubscriptionKey()
                })
            };
            const url = this.config[this.currentEnv].catalogConfig['apim.api.catalog.path'] +
            this.config[this.currentEnv].catalogConfig['apim.api.catalog.departments.endpoint'] + '?key=' + this.objDeals.apiKey + '&storeId=' + this._userInfoService.getShopStoreId();
           
            return this._http.get(url, httpOptions);
        } else {
            const url = this._aemService.getDealsFilter() + '?key=' + this._aemService.getProductGridPage() + '&storeId=' + this._userInfoService.getShopStoreId();
            return this._http.get(url);
        }
    }

    /**
     * Emit current filter from 'aisle' param.
     * 
     * @param {string} filterName
     */
    public setCurrentFilterDeals(filterName) : void{
        if(filterName){
            filterName = filterName.replace(/& |,/g, '').replace(/ /g, '-');
            this._dealsCurrentFilter.next(filterName);
        }
    }
}
